<h2 class="text-center" mat-dialog-title mat-dialog-draggable-title style="margin-bottom: 0px !important;">
  <span style="color:  #F10000">{{'kyc.fail_title' | translate}}</span>
<!--  <button type="button" class="close" aria-label="Close" (click)="onNoClick()">-->
<!--    <span aria-hidden="true">&times;</span>-->
<!--  </button>-->
</h2>
<mat-divider></mat-divider>
<div class="row">
  <div class="col-2 pr-0" style="text-align: center;padding-left: 0px !important; padding-top: 15px;">
    <em class="fa fa-warning text-danger large"></em>
  </div>
  <div class="col-10 pl-0">
    <div [innerHTML]="data.message | translate" style=" padding: 5px 7px 15px; font-size: medium; overflow-wrap: break-word;"></div>
  </div>
</div>


<div mat-dialog-actions class="justify-content-center">

  <!--build icon, set default cancel-->
  <!-- <button mat-stroked-button color="primary" type="button" (click)="onNoClick()" cdkFocusInitial>
    <mat-icon class="mr-0">cancel</mat-icon>{{'button.cancel' | translate}}
  </button> -->
  <button class="ml-2" mat-raised-button color="primary" [mat-dialog-close]="true">
    <mat-icon class="mr-0">done</mat-icon>{{'button.close' | translate}}
  </button>
</div>
